import { useMemo } from 'react';
import { Form } from 'react-final-form';

import { backendAnalyticsTrack } from 'analytics/backend';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import { InitialValues } from 'forms/types';
import useNavigatorTracking from 'hooks/useNavigatorTracking';
import Steps from 'hooks/useNavigatorTracking/steps';
import goToDiPath from 'utils/goToDiPath';

import { HEADING } from './constants';
import PolicyFeaturesForm from './form';
import { PolicyFeaturesFormValues } from './form/types';
import { useGetPolicyFeaturesQuery } from './graphql/GetPolicyFeatures';
import { useUpdatePolicyFeaturesMutation } from './graphql/UpdatePolicyFeatures';
import buildInitialValues from './utils/buildInitialValues';
import { validate } from './utils/validate';

const PolicyFeatures = () => {
  const trackStepCompleted = useNavigatorTracking(Steps.PolicyFeatures);
  const { data, loading } = useGetPolicyFeaturesQuery();
  const initialValues = useMemo(() => buildInitialValues(data), [data]);

  const [updatePolicyFeatures] = useUpdatePolicyFeaturesMutation({
    onCompleted: () => {
      backendAnalyticsTrack({
        action: 'track_disability_navigator_completed',
      });
      trackStepCompleted();
      goToDiPath('health/basics');
    },
  });

  const onSubmit = async (values: PolicyFeaturesFormValues) => {
    await updatePolicyFeatures({
      variables: {
        input: values,
      },
    });
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent heading={HEADING} title={Steps.PolicyFeatures}>
      <Form<PolicyFeaturesFormValues, InitialValues<PolicyFeaturesFormValues>>
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
      >
        {(formProps) => <PolicyFeaturesForm {...formProps} />}
      </Form>
    </NavigatorContent>
  );
};

export default PolicyFeatures;
